import { Alert } from 'AWS-UI-Components-React';
import React from 'react';
import { TAX_ADJUSTMENTS_COMPONENT } from './utils';

export class TaxAdjustmentsAlert extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {loading, component } = this.props;
    if (TAX_ADJUSTMENTS_COMPONENT.includes(component) && !loading) {
      return (
        <div>
          <Alert>
              <div> Tax adjustments have been subtracted from DUCSI ETL cost in marketplace BR. </div>
          </Alert>
        </div>
      );
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/mapper/tax_adjustments_alert.jsx